import { useEffect, useRef } from "react";
import Hls from "hls.js";

interface MobileVideoPlayerProps {
  src: string;
  className?: string;
}

const MobileVideoPlayer = ({ src, className = "" }: MobileVideoPlayerProps) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    let hls: Hls | null = null;

    if (Hls.isSupported()) {
      hls = new Hls({
        enableWorker: true,
        lowLatencyMode: false,
      });
      hls.loadSource(src);
      hls.attachMedia(video);
      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        video.play().catch(() => {
          // Autoplay was prevented
        });
      });
    } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
      // Native HLS support (Safari)
      video.src = src;
      video.play().catch(() => {
        // Autoplay was prevented
      });
    }

    return () => {
      if (hls) {
        hls.destroy();
      }
    };
  }, [src]);

  return (
    <div className={`w-full ${className}`}>
      <video
        ref={videoRef}
        className="w-full h-auto rounded-lg shadow-2xl"
        playsInline
        muted
        loop
        autoPlay
        controls={false}
        preload="auto"
      />
    </div>
  );
};

export default MobileVideoPlayer;

